import React from 'react';
import { Box, Paper, Typography, Card, CardContent } from '@mui/material';
import { Label as LabelIcon } from '@mui/icons-material';
import GoogleAdSense from './GoogleAdSense';

// Ad Slot IDs from Google AdSense Dashboard
export const AD_SLOTS = {
  BUSINESS_SIDEBAR: '3003488070',
  // Add more ad slots here as you create them in AdSense:
  // BUSINESS_MOBILE: 'XXXXXXXXXX',
  // HOMEPAGE_BANNER: 'XXXXXXXXXX',
};

/**
 * Desktop Sponsored Ad - For right sidebar on business pages
 * Uses fixed 300x250 size (Medium Rectangle) - most common sidebar ad
 * No layout shift, predictable UI
 */
export const DesktopSponsoredAd = ({ adSlot = AD_SLOTS.BUSINESS_SIDEBAR }) => {
  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 2, border: 'none' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <LabelIcon fontSize="small" color="action" />
        <Typography variant="subtitle2" color="text.secondary">
          Sponsored
        </Typography>
      </Box>
      
      {/* Fixed 300x250 - Medium Rectangle (best for sidebars) */}
      <GoogleAdSense 
        adSlot={adSlot}
        adFormat="fixed"
        width={300}
        height={250}
      />
    </Paper>
  );
};

/**
 * Mobile Sponsored Ad - For mobile sidebar drawer
 * Uses fixed 300x250 but contained in a responsive wrapper
 * Scales down on very small screens
 */
export const MobileSponsoredAd = ({ adSlot = AD_SLOTS.BUSINESS_SIDEBAR }) => {
  return (
    <Card sx={{ mb: 2 }}>
      <CardContent sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center',
        px: 1 
      }}>
        <Typography 
          variant="subtitle2" 
          color="text.secondary" 
          sx={{ mb: 2, alignSelf: 'flex-start' }}
        >
          Sponsored
        </Typography>
        
        {/* Container that scales on small screens */}
        <Box sx={{ 
          width: '100%', 
          maxWidth: 300,
          display: 'flex',
          justifyContent: 'center'
        }}>
          <GoogleAdSense 
            adSlot={adSlot}
            adFormat="fixed"
            width={300}
            height={250}
          />
        </Box>
      </CardContent>
    </Card>
  );
};

/**
 * Responsive Ad - Use when you want Google to optimize size
 * Good for inline content areas where width varies
 * May cause some layout shift
 */
export const ResponsiveAd = ({ 
  adSlot = AD_SLOTS.BUSINESS_SIDEBAR,
  minHeight = 250 
}) => {
  return (
    <Box sx={{ my: 2 }}>
      <Typography 
        variant="caption" 
        color="text.secondary" 
        sx={{ display: 'block', mb: 1 }}
      >
        Sponsored
      </Typography>
      
      <GoogleAdSense 
        adSlot={adSlot}
        adFormat="auto"
        height={minHeight}
        fullWidthResponsive={true}
      />
    </Box>
  );
};